const entryItemRefIsElement = entry => entry[0].current instanceof Element;
export default entryItemRefIsElement;